import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import type { QueryOpts } from "./useTrackingEvents";

export interface TopUser {
	user_id: string;
	full_name: string | null;
	job_title: string | null;
	org_team_level_one: string | null;
	event_count: number;
	last_active_at: string | null;
}

export interface TopUsersArgs {
	event?: string;
	from: Date;
	to: Date;
	limit?: number;
	order?: "count" | "recent";
}

const fetchTopUsers = async (args: TopUsersArgs): Promise<TopUser[]> => {
	const { data } = await cmsClient.get<TopUser[]>("/tracking/users/", {
		params: {
			...(args.event ? { event: args.event } : {}),
			from: args.from.toISOString(),
			to: args.to.toISOString(),
			limit: args.limit ?? 25,
			order: args.order ?? "count"
		}
	});
	return data;
};

const useTrackingTopUsers = (args: TopUsersArgs, options?: QueryOpts) =>
	useQuery(
		[
			"tracking",
			"top-users",
			args.event ?? "all",
			args.from.toISOString(),
			args.to.toISOString(),
			String(args.limit ?? 25),
			args.order ?? "count"
		],
		() => fetchTopUsers(args),
		options
	);

export default useTrackingTopUsers;
